import { push } from 'connected-react-router';
import {
	getApps,
	getSingleApp,
	uploadApk,
	downloadApk,
	deleteApk,
	deleteApp,
	selectActiveApk,
	getCheckedAppsInfo,
	getInRetailCheckedApps,
	saveInRetailCheckedApps,
	getSingleAppFromGlobalMarket,
    updateMobileApp
} from '../helpers/marketService';
import { checkError, receiveErrorAlert, receiveSuccessAlert, closeAlert, requestIsPending } from './commonsActions';
import { loadStorageState, saveStorageState } from '../helpers/localStorageService';
import {secureFetch} from "../helpers/authService";
import {API_UPLOAD_URL} from "../helpers/constants";

/*
 * action types
 */
export const FETCH_APPS_BEGIN   = 'FETCH_APPS_BEGIN';
export const GET_APPS = 'GET_APPS';
export const GET_FILTERED_APPS = 'FILTERED_APPS';
export const GET_SINGLE_APP = 'GET_SINGLE_APP';

export const LOCAL_GET_SELECTED_APPS_BEGIN   = 'LOCAL_GET_SELECTED_APPS_BEGIN';
export const LOCAL_GET_SELECTED_APPS_SUCCESS = 'LOCAL_GET_SELECTED_APPS_SUCCESS';
export const LOCAL_SAVE_SELECTED_APPS_BEGIN   = 'LOCAL_SAVE_SELECTED_APPS_BEGIN';
export const LOCAL_SAVE_SELECTED_APPS_SUCCESS = 'LOCAL_SAVE_SELECTED_APPS_SUCCESS';

export const FETCH_CHECKED_APPS_INFO_BEGIN = 'FETCH_CHECKED_APPS_INFO_BEGIN';
export const FETCH_CHECKED_APPS_INFO_SUCCESS = 'FETCH_CHECKED_APPS_INFO_SUCCESS';

export const GET_RETAIL_CHECKED_APPS_BEGIN = 'GET_RETAIL_CHECKED_APPS_BEGIN';
export const GET_RETAIL_CHECKED_APPS_SUCCESS = 'GET_RETAIL_CHECKED_APPS_SUCCESS';
export const SAVE_RETAIL_CHECKED_APPS_BEGIN = 'SAVE_RETAIL_CHECKED_APPS_BEGIN';
export const SAVE_RETAIL_CHECKED_APPS_SUCCESS = 'SAVE_RETAIL_CHECKED_APPS_SUCCESS';

export const GET_GLOBAL_MARKET_SINGLE_APP = 'GET_GLOBAL_MARKET_SINGLE_APP';

export const UPLOAD_SINGLE_APK = 'UPLOAD_SINGLE_APK';
/*
 * action creators
 */

export const getAppsList = apps => ({
	type: GET_APPS,
	payload: {
		apps: apps.data,
		numberOfElements : apps.numberOfElements,
		totalElements: apps.totalElements,
		totalPages: apps.totalPages
	}
});

// export const getFilteredAppsList = apps => ({
// 	type: GET_FILTERED_APPS,
// 	apps
// });

export const getAppItem = singleApp => ({
	type: GET_SINGLE_APP,
	singleApp
});

export const fetchApps = query => dispatch => {
	dispatch({ type: FETCH_APPS_BEGIN });
	return getApps(query).then(res => {
		dispatch(getAppsList(res));
		dispatch(filteringApps());
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const filteringApps = filterWord => (dispatch, getState) => {
	const state = getState();
	let filteredApps = null;
	if (filterWord) {
		filteredApps = state.appsList.apps.filter( app => {
			return app.appLabel.toLowerCase().indexOf(filterWord.toLowerCase()) !== -1;
		});
	} else {
		filteredApps = state.appsList.apps;
	}

	dispatch({
		type: GET_FILTERED_APPS,
		apps: filteredApps
	});
};

export const getOneApp = apId => dispatch => {
	dispatch(requestIsPending(true));
	return getSingleApp(apId).then(res => {
		dispatch(getAppItem(res.data));
		dispatch(requestIsPending(false));
		return res;
	}, error => {
		dispatch(requestIsPending(false));
		dispatch(push('/dashboard/market'));
		dispatch(checkError(error));
		//dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updateSingleMobileApp = app => dispatch => {
    dispatch(requestIsPending(true));
    return updateMobileApp(app).then(res => {
        dispatch(requestIsPending(false));
        return res;
    }, error => {
        dispatch(requestIsPending(false));
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
}

export const getOneAppFromGlobalMarket = packageName => dispatch => {
	dispatch(requestIsPending(true));
	return getSingleAppFromGlobalMarket(packageName).then(res => {
		/* Checking for unique data - remove in the future */
		const resultApk = res.data[0] ? {...res.data[0]} : null;
		if (resultApk && resultApk.apks) {
			const filteredApks = resultApk.apks.filter((obj, pos, arr) => {
				return arr.map(mapObj => mapObj.versionCode).indexOf(obj.versionCode) === pos;
			});
			resultApk.apks = filteredApks;
		}
		/* end of */
		dispatch({
			type: GET_GLOBAL_MARKET_SINGLE_APP,
			singleGlobalMarketApp: resultApk
		});
		dispatch(requestIsPending(false));
		return res;
	}, error => {
		dispatch(requestIsPending(false));
		dispatch(checkError(error));
		//dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const uploadNewApk = newApk => dispatch => {
    let progress = 0;
    const totalFilesNumber = newApk.length;
    const maxNumOfWorkers = 4;
    let numOfWorkers = 0;
    let taskIndex = 0;
    let activeFileName = 'file';
    const resultData = [];
    const tasks = newApk.map( file => {
        activeFileName = file.get('filename') ? file.get('filename') : 'noname';
        return {fileName: activeFileName, fn: uploadApk(file)};
    });

    return new Promise(done => {
        const handleResult = fileName => res => {
            let result = null;
            if (res instanceof Error) {
                console.log('error', result);
                result = { err: true, file: fileName, message: res.body.error };
                console.error(fileName, 'ERROR FILE UPLOAD: ', res);
                dispatch(receiveErrorAlert(res.body.error));
                setTimeout(() => {
                    dispatch(closeAlert());
                }, 10000);
            } else {
                if (res && res.data) {
                    if (res.data.status.status === 'ERROR') {
                        result = { err: true, file: fileName, message: res.data.status.message };
                    }
                    if (res.data.status.status === 'OK') {
                        result = { err: false, file: fileName };
                    }
                } else {
                    result = { err: true, file: fileName, message: 'ERROR FILE UPLOAD' };
                    console.error(fileName, 'ERROR FILE UPLOAD');
                }
            }
            progress = progress + 1;
            dispatch({
                type: UPLOAD_SINGLE_APK,
                payload: {
                    progressPercent: (progress * 100 / totalFilesNumber).toFixed()
                }
            });
            resultData.push(result);
            numOfWorkers--;
            getNextTask();
        };
        const getNextTask = () => {
            if (numOfWorkers < maxNumOfWorkers && taskIndex < tasks.length) {
                tasks[taskIndex].fn
                    .then(handleResult(tasks[taskIndex].fileName))
                    .catch(handleResult(tasks[taskIndex].fileName));
                taskIndex++;
                numOfWorkers++;
                getNextTask();
            } else if (numOfWorkers === 0 && taskIndex === tasks.length) {
                done(resultData);
            }
        };
        getNextTask();
    }).then(res => {
        const getErrors = res.filter(item => item.err === true);
        const message = `Total files: ${progress}\n Success: ${res.length - getErrors.length}\n Error: ${getErrors.length}\n`;
        const comment = getErrors.map( elem => `${elem.message ? elem.message + ' - ' : ''} ${elem.file}`).join('\n');
        dispatch({
            type: UPLOAD_SINGLE_APK,
            payload: {
                progressPercent: 0
            }
        });
        dispatch(fetchApps());
        return {
            message,
            comment
        };
    });
};

export const downloadSingleApk = apkId => dispatch => {
	return downloadApk(apkId).then(res => {
		console.log('download res___', res);
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const deleteSingleApk = apkId => dispatch => {
	return deleteApk(apkId).then(res => {
		dispatch(fetchApps());
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updateActiveApk = (apkId, retailItemId) => dispatch => {
	return selectActiveApk(apkId, retailItemId).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const deleteSingleApp = appId => dispatch => {
	return deleteApp(appId).then(res => {
		dispatch(fetchApps());
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const localGetSelectedApps = () => dispatch => {
	dispatch({ type: LOCAL_SAVE_SELECTED_APPS_BEGIN });
	return loadStorageState('selected_apps').then(res => {
		res = res ? res : [] ;
		dispatch({
			type: LOCAL_GET_SELECTED_APPS_SUCCESS,
			payload: {
				checkedApps: res
			}
		});
		return res
	}, error => {
		console.error(error);
	})
};

export const localSaveSelectedApps = selectedApps => dispatch => {
	dispatch({ type: LOCAL_SAVE_SELECTED_APPS_BEGIN });
	return saveStorageState('selected_apps', selectedApps).then(res => {
		if (res) {
			dispatch({ type: LOCAL_SAVE_SELECTED_APPS_SUCCESS });
			console.log('save success');
		} else {
			console.log('something went wrong');
		}
	}, error => {
		console.error(error);
	})
};

export const fetchCheckedAppsInfo = apps => dispatch => {
	dispatch({ type: FETCH_CHECKED_APPS_INFO_BEGIN });
	return getCheckedAppsInfo(apps).then(res => {
		dispatch({
			type: FETCH_CHECKED_APPS_INFO_SUCCESS,
			payload: {
				checkedAppsInfo: res.data
			}
		});
		console.log('res___', res)
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const getInRetailAppsList = (companyId, checkedAppsPackageNames) => dispatch => {
	dispatch({ type: GET_RETAIL_CHECKED_APPS_BEGIN });
	return getInRetailCheckedApps(companyId, checkedAppsPackageNames).then(res => {
		dispatch({
			type: GET_RETAIL_CHECKED_APPS_SUCCESS,
			payload: {
				inRetailAppsList: res.data && res.data.length ? res.data.map(app => app.mobileApp.packageName) : []
			}
		});
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const saveInRetailAppsList = (companyId, mobileAppIds) => dispatch => {
	dispatch({ type: SAVE_RETAIL_CHECKED_APPS_BEGIN });
	return saveInRetailCheckedApps(companyId, mobileAppIds).then(res => {
		dispatch({
			type: SAVE_RETAIL_CHECKED_APPS_SUCCESS,
			payload: {
				savedInRetailAppsList: res.data
			}
		});
		console.log('res___', res)
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};



// WEBPACK FOOTER //
// ./src/actions/marketActions.js